"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const Resource_1 = __importDefault(require("../Resource"));
const ScenarioResponseResource_1 = __importDefault(require("./Scenario/ScenarioResponseResource"));
const PosterResponseResource_1 = __importDefault(require("./Poster/PosterResponseResource"));
const ProjectFormat_1 = require("../../enums/ProjectFormat/ProjectFormat");
const ProjectTheme_1 = require("../../enums/ProjectTheme/ProjectTheme");
const UserPublicResponseResource_1 = __importDefault(require("../User/UserPublicResponseResource"));
const ProjectReason_1 = require("../../enums/ProjectReason");
const FileResponseResource_1 = __importDefault(require("../File/FileResponseResource"));
const EProjectStatus_1 = require("../../enums/Project/Status/EProjectStatus");
const ProjectTeamResponseResource_1 = __importDefault(require("./Config/Team/ProjectTeamResponseResource"));
const ProjectPurposeResponseResource_1 = __importDefault(require("../ProjectPurpose/ProjectPurposeResponseResource"));
const ProjectLikeResponseResource_1 = require("./ProjectLikeResponseResource");
class ProjectResponseResource extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.title_en = null;
        this.pitch_en = null;
        this.reason = ProjectReason_1.EProjectReason.PROTECT;
        this.format = ProjectFormat_1.EProjectFormat.long_metrage;
        this.theme = ProjectTheme_1.EProjectTheme.biopic;
        this.likes = [];
    }
}
exports.default = ProjectResponseResource;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProjectResponseResource.prototype, "id", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProjectResponseResource.prototype, "title", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProjectResponseResource.prototype, "pitch", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProjectResponseResource.prototype, "title_en", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProjectResponseResource.prototype, "pitch_en", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => ProjectPurposeResponseResource_1.default),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], ProjectResponseResource.prototype, "purpose", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProjectResponseResource.prototype, "componentName", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], ProjectResponseResource.prototype, "featured", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => ScenarioResponseResource_1.default),
    __metadata("design:type", Object)
], ProjectResponseResource.prototype, "scenario", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => PosterResponseResource_1.default),
    __metadata("design:type", Object)
], ProjectResponseResource.prototype, "poster", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProjectResponseResource.prototype, "reason", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProjectResponseResource.prototype, "format", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProjectResponseResource.prototype, "theme", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => UserPublicResponseResource_1.default),
    __metadata("design:type", UserPublicResponseResource_1.default)
], ProjectResponseResource.prototype, "author", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => FileResponseResource_1.default),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProjectResponseResource.prototype, "cv", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(EProjectStatus_1.EProjectStatus),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProjectResponseResource.prototype, "status", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => ProjectLikeResponseResource_1.ProjectLikeResponseResource),
    __metadata("design:type", Array)
], ProjectResponseResource.prototype, "likes", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProjectResponseResource.prototype, "discord", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProjectResponseResource.prototype, "instagram", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProjectResponseResource.prototype, "x", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProjectResponseResource.prototype, "linkedin", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => ProjectTeamResponseResource_1.default),
    __metadata("design:type", Object)
], ProjectResponseResource.prototype, "projectTeam", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProjectResponseResource.prototype, "publishedAt", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProjectResponseResource.prototype, "archivedAt", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProjectResponseResource.prototype, "createdAt", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProjectResponseResource.prototype, "updatedAt", void 0);
